export const ChatWindowSkeleton = () => {
  return (
    <div
      className="ui-z-[1250] ui-rounded-3xl"
      style={{
        transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
      }}
    >
      <div
        id="chat_wrapper_body"
        className="ui-relative ui-flex ui-flex-col ui-w-96 mobile-landscape:ui-w-[600px] ui-max-w-[calc(100vw-2.5rem)] ui-h-[800px] ui-max-h-[calc(100dvh-88px)] ui-rounded-3xl ui-rounded-br-none ui-shadow-2xl ui-overflow-hidden ui-bg-white"
      >
        <div className="ui-h-full ui-flex ui-flex-col">
          <div className="ui-h-[64px] ui-rounded ui-bg-gray-300 ui-animate-pulse" />
          <div className="ui-flex-1 ui-px-4 ui-py-6 ui-flex ui-flex-col ui-gap-4 ui-animate-pulse">
            <div className="ui-h-[72px] ui-w-[90%] ui-rounded-3xl ui-rounded-bl-none ui-bg-gray-300" />
            <div className="ui-h-[324px] ui-w-[90%] ui-self-end ui-rounded-3xl ui-rounded-br-none ui-bg-gray-300" />
          </div>
          <div className="ui-h-[164px] ui-bg-gray-100 ui-flex ui-flex-col-reverse ui-px-4 ui-py-5">
            <div className="ui-h-[48px] ui-rounded-full ui-bg-gray-300 ui-animate-pulse" />
          </div>
        </div>
      </div>
    </div>
  );
};
